import { Box, styled } from '@mui/material';

import { QuillTheme, RichTextEditorProps } from './RichTextWidget.interface';

interface StyledRichTextEditorProps extends RichTextEditorProps {
  theme: QuillTheme;
  $backgroundImage: string;
}

export const RichTextEditorRoot = styled(Box)<StyledRichTextEditorProps>(
  (props) => `
  position: relative;
  top: 0px;

  .container {
    position: relative;
    top: 0px;
  }

  .ql-picker-options {
    max-height: 200px;
    overflow: auto;
    min-width: 75px;
  }

   .ql-editor {
    background-image: url('${props.$backgroundImage}');
    background-size: cover;
    color: ${props.textColor};
    font-size: ${props.fontSizeEditor};
    line-height: ${props.lineHeightEditor}
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    
  }

  .ql-picker-label:before {
    ${props.theme === QuillTheme.TOOLTIP ? 'content: attr(data-label)' : ''};
  }

  .pre {
    white-space: pre-wrap;
  }

  .ql-toolbar.ql-snow .ql-formats {
    margin-right: 0px;
  }

  .ql-toolbar {
    background-color: #F5F5F5;
    border-bottom: 0px;
    border-radius: 10px 10px 0px 0px;
  }

  .ql-toolbar .ql-color-picker .ql-picker-label > svg > line:first-child {
    stroke: ${props.textColor}
  }

  .ql-container {
    border-radius: 4px;
  }
`,
);
